import { isToastNotificationsActivated } from '@functions/featureFlag';
import { IToast, IToastToAdd } from '@notifications/components/Toast/Toast.type';
import { AxiosError } from 'axios';
import { generateUUID } from 'src/functions/functions';

function addToast(toasts: IToast[], newToast: IToastToAdd): IToast[] {
	if (!isToastNotificationsActivated()) return [];

	let newToastDetails = newToast.details;

	const { rawError } = newToast;
	if (rawError instanceof AxiosError) {
		newToastDetails ||= rawError?.message ?? rawError?.response?.data?.error?.message?.split('.')[0];
	} else if (rawError instanceof Error) {
		newToastDetails ||= rawError?.message;
	} else if (rawError) {
		newToastDetails ||= JSON.stringify(rawError);
	}

	// usage of || instead of ?? to avoid falsy values as uuid
	const newToastId = newToast.uuid || generateUUID();

	const toastIndex = toasts.findIndex((toast) => toast.uuid === newToastId);

	// push new toast if it doesn't exist
	if (toastIndex === -1) {
		const toast: IToast = { ...newToast, uuid: newToastId, details: newToastDetails, nonce: 1 };
		return [...toasts, toast];
	}

	const updatedToastsArray = [...toasts];

	// set the nonce by default to 1 if it's not set to be able to cast it to number later
	updatedToastsArray[toastIndex].nonce ||= 1;

	const updatedNonce = newToast.ignoreNonce
		? updatedToastsArray[toastIndex].nonce
		: // Non-null assertion operator is possible because we set the nonce to 1 if it's not set before
		  updatedToastsArray[toastIndex].nonce! + 1;

	const toast: IToast = { ...newToast, uuid: newToastId, details: newToastDetails, nonce: updatedNonce };
	updatedToastsArray[toastIndex] = toast;

	return updatedToastsArray;
}

function removeToast(toasts: IToast[], id: string): IToast[] {
	if (!isToastNotificationsActivated()) return [];
	return toasts.filter((toast) => toast.uuid !== id);
}

export { addToast, removeToast };
